(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 767px)');
  const MIN_THUMB_PX = 24;
  const BOUND_ATTR = 'data-plp-nav-bound';

  function destroyFlickity(slider) {
    if (!slider || !window.theme?.Flickity) return;

    const flkty = window.theme.Flickity.data(slider);
    if (flkty?.isActive) {
      flkty.destroy();
    }

    slider.classList.add('carousel--inactive');
  }

  function syncFlickityState(section) {
    const slider = section.querySelector('[data-plp-category-nav]');
    if (!slider) return;

    destroyFlickity(slider);
  }

  /* The carousel appends a trailing gutter via ::after, which counts towards
     scrollWidth. Measure the pills themselves so a nav that fits does not get
     a progress bar for those few phantom pixels. */
  function itemsOverflow(slider) {
    const items = slider.querySelectorAll('.list-collections__item');
    const lastItem = items[items.length - 1];
    if (!lastItem) return 0;

    const contentRight =
      lastItem.getBoundingClientRect().right - slider.getBoundingClientRect().left + slider.scrollLeft;

    return contentRight - slider.clientWidth;
  }

  function updateProgress(slider, track, fill) {
    if (!slider || !track || !fill) return;

    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const canScroll = maxScroll > 1 && itemsOverflow(slider) > 1 && MOBILE_MQ.matches;

    track.hidden = !canScroll;
    if (!canScroll) return;

    const trackWidth = track.clientWidth;
    const thumbWidth = Math.max((slider.clientWidth / slider.scrollWidth) * trackWidth, MIN_THUMB_PX);
    const maxTranslate = Math.max(trackWidth - thumbWidth, 0);
    const ratio = slider.scrollLeft / maxScroll;

    fill.style.width = thumbWidth + 'px';
    fill.style.transform = 'translateX(' + ratio * maxTranslate + 'px)';
  }

  function bindSection(section) {
    if (section.getAttribute(BOUND_ATTR) === 'true') return;

    const slider = section.querySelector('[data-plp-category-nav]');
    const track = section.querySelector('[data-plp-nav-progress]');
    const fill = section.querySelector('[data-plp-nav-progress-fill]');

    if (!slider || !track || !fill) return;

    section.setAttribute(BOUND_ATTR, 'true');
    syncFlickityState(section);

    const onScroll = () => updateProgress(slider, track, fill);
    const onResize = () => {
      syncFlickityState(section);
      updateProgress(slider, track, fill);
    };

    slider.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    MOBILE_MQ.addEventListener('change', onResize);
    document.addEventListener('theme:resize:width', onResize);

    if (slider.matches?.('grid-slider')) {
      slider.addEventListener('theme:slider:resize', onResize);
    }

    const observer = new MutationObserver(() => {
      if (slider.classList.contains('flickity-enabled')) {
        destroyFlickity(slider);
        requestAnimationFrame(() => updateProgress(slider, track, fill));
      }
    });

    observer.observe(slider, { attributes: true, attributeFilter: ['class'] });
    section._plpNavObserver = observer;

    onResize();
  }

  function init(root) {
    root.querySelectorAll('.list-collections-section--plp-nav').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('.list-collections-section--plp-nav') || event.target;

    if (section?.classList?.contains('list-collections-section--plp-nav')) {
      section.removeAttribute(BOUND_ATTR);
      if (section._plpNavObserver) {
        section._plpNavObserver.disconnect();
        section._plpNavObserver = null;
      }
      bindSection(section);
    }
  });
})();
